import { Organisation } from "../models";
export class UserInfo {
    organisation: Organisation;
    displayName: string;
}



// WEBPACK FOOTER //
// ./src/app/models/userInfo.ts